<template>
    <div class="editor-layer-wrapper" :id="'layer_item_' + layer.itemId">
        <div class="parent-layer" :class="{ active: layer.itemSelected }" @click="selectElement()">
            <div class="layer-icon">
                <div class="icon-cicle">
                </div>
            </div>
            <div class="layer-name">
                <span>{{ layer.itemName }}</span>
            </div>
        </div>
        <div class="children-layer">
            <EditorChildrenLayerViewer v-for="(item, index) in layer.children" :key="index" :layer="item" @selectElement="() => {
                item.itemSelected = true;
            }">
            </EditorChildrenLayerViewer>
        </div>
    </div>
</template>
<script>
import { eventBus } from "@/main";
export default {
    name: "editor-layer",
    components: {
        EditorChildrenLayerViewer: () => import('./editor_layer_viewer.vue')
    },
    props: {
        layer: {
            type: Object,
            default: () => {
                return {
                    itemName: "Layer 1",
                    children: []
                };
            }
        }
    },

    data() {
        return {

        };
    },
    mounted() {

    },
    methods: {
        selectElement() {
            let vm = this;
            eventBus.$emit("onElementSelected", vm.layer);
            vm.$emit("selectElement", vm.layer);
        },
    },
};
</script>
  
<style lang="scss" scoped>
$assets: "~@/assets";

.editor-layer-wrapper {
    width: 100%;
    border-left: 1px solid #f0f0f0;
    padding: 5px;

    .parent-layer {
        display: flex;
        align-items: center;
        cursor: pointer;
        width: 100%;
        padding: 4px 5px;

        &:hover {
            background-color: #ebebeb;
        }

        &.active {
            background-color: #ebebeb;
        }

        .layer-icon {
            margin-right: 5px;

            .icon-cicle {
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background-color: #000;
            }
        }
    }

    .children-layer {
        padding-left: 25px;
        margin-top: 5px;
    }
}
</style>